import {Col, Form, Radio, Row} from 'antd';
import {FormInstance} from 'antd/lib/form';
import {Footer} from 'antd/lib/layout/layout';
import _ from 'lodash';
import React, {useContext, useEffect} from 'react';
import {FilterLabel} from '../../../../containers/QueryBuilder/types/Query';
import DiagnosisTree from '../../../create/DiagnosisTree';
import {LabelAndValue} from '../../../create/types/LabelAndValue';
import {QueryBuilderContext, QueryBuilderContextType} from '../../QueryBuilderContext';

interface Props {
    form: FormInstance
    fieldId: string
    fieldName: string // label in UI
    operatorId: string
    operatorChoices: LabelAndValue[]
    operatorNotes?: string
    treeData: [],
    useIpdn?: boolean
}

const DiagnosisFilter = ({
    form,
    fieldId,
    fieldName,
    operatorId,
    operatorChoices,
    operatorNotes,
    treeData,
    useIpdn = false
}: Props) => {

    const onChange = () => {}

    const {userQuery, dataset, setOnFilterFinish,} = useContext(QueryBuilderContext) as QueryBuilderContextType

    let value = undefined
    const qf = userQuery.query.filters.find(i => i.code === operatorId)
    if (qf) {
        value = qf.value
    }

    let initOper: string | undefined

    if (operatorChoices) {
        initOper = value ?? operatorChoices[0].value
    }

    const icd10Tree = treeData;

    useEffect(() => {
        const callback = () => {
            const field = userQuery.query.filters.find(i => i.code === operatorId)
            const value = form.getFieldValue(operatorId)
            if (operatorChoices) {
                const parent = _.find(userQuery.query.filterLabels, {field: fieldId}) as FilterLabel | undefined
                const child = _.find(operatorChoices, {value})

                if (parent && child) {
                    parent.title = `${child.label} ${parent.title}`
                }
            }
            if (field) {
                field.value = value
            } else {
                    userQuery
                        .query
                        .filters
                        .push({
                            code: operatorId,
                            type: dataset,
                            value: value,
                            distinct: false
                        })

            }
        }
        setOnFilterFinish(() => callback)
        // including additional dependencies causes to many rerenders
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataset, fieldId, operatorId])

    const showDiagnosisTreeFooter = () => {
        if (initOper && operatorChoices) {
            return <>
                <Footer style={{padding: '10px'}} data-testid={'diagnosis-tree-footer'}>
                    <Row data-testid={'diagnosis-filter-operators'}>
                        <Col span={24}>
                            <Form.Item name={operatorId} initialValue={initOper} style={{marginBottom: '0px'}}>
                                <Radio.Group onChange={onChange}>
                                    {
                                        operatorChoices
                                            .map(i => <Radio key={i.value} value={i.value}><b>{i.label}</b></Radio>)
                                    }
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        {operatorNotes}
                    </Row>
                </Footer>
            </>
        }
    }

    return <>
        {
            <Row data-testid={'diagnosis-filter'}>
                <Col span={24}>
                    <DiagnosisTree
                        fieldId={fieldId}
                        fieldName={undefined}
                        fieldPlaceHolder={`Select ${fieldName}`}
                        form={form}
                        isDisabled={false}
                        icd10tree={icd10Tree}
                        useIpdn={useIpdn}
                    />
                </Col>
            </Row>
        }
        {showDiagnosisTreeFooter()}
    </>

}

export default DiagnosisFilter